import { useLocation, Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - 痴汉电车",
    description: "你访问的页面不存在，可能已被移动或删除。返回首页继续浏览痴汉电车影视作品与剧情介绍。",
    suffix: false,
  });

  return (
    <SiteLayout>
      <section className="relative w-full px-4 md:px-8 pt-32 md:pt-44 pb-24 md:pb-32 overflow-hidden">
        <span className="absolute inset-x-0 top-10 text-center font-heading text-[7rem] md:text-[15rem] leading-none text-background-100 select-none pointer-events-none">
          404
        </span>
        <div className="relative max-w-xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-primary-500/40 bg-primary-500/10 text-primary-300 text-xs tracking-[0.2em] font-label">
            PAGE NOT FOUND
          </span>
          <h1 className="mt-6 font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
            这节车厢不存在
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            你访问的页面可能已被移动或删除。请检查链接，或从下面的入口重新开始浏览。
          </p>
          <p className="mt-3 font-mono text-xs text-foreground-500 break-all">{location.pathname}</p>
          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <Link
              to="/"
              className="px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/category"
              className="px-6 py-3 rounded-md border border-background-300/70 text-foreground-800 hover:border-primary-500 text-sm transition-colors whitespace-nowrap"
            >
              浏览全部作品
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}